if (!customElements.get('x-tabs')) {
  class DoenTabs extends HTMLElement {
    constructor() {
      super()
      this.tabs = this.querySelectorAll('x-tab')
    }

    changeTab(selectedTab) {
      this.tabs.forEach(tab => (tab === selectedTab ? tab.show() : tab.hide()))
    }
  }

  customElements.define('x-tabs', DoenTabs)

  class DoenTab extends HTMLElement {
    constructor() {
      super()
      this.parent = this.closest('x-tabs')
      this.content = document.getElementById(this.getAttribute('aria-controls'))
      this.handleClick = this.onClick.bind(this)

      this.updateMarkup()
    }

    connectedCallback() {
      this.addEventListener('click', this.handleClick)
      this.addEventListener('keydown', (event) => {
        if (event.code === 'Enter') {
          this.click()
        }
      })
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick)
      this.removeEventListener('keydown', (event) => {
        if (event.code === 'Enter') {
          this.click()
        }
      })
    }

    isVisible() {
      return this.getAttribute('aria-selected') === 'true'
    }

    updateMarkup() {
      const content = this.innerHTML
      this.innerHTML = `<span class="tab__label">${content}</span>`

      const index = Array.from(this.parent.tabs).findIndex(tab => tab === this)

      if (index > 0) {
        const diamond = document.getElementById('tab-separator')
        this.parentElement.insertBefore(diamond.content.cloneNode(true), this)
      }
    }

    onClick() {
      this.parent.changeTab(this)
    }

    show() {
      this.setAttribute('aria-selected', true)
      this.content.setAttribute('aria-hidden', false)
    }

    hide() {
      this.setAttribute('aria-selected', false)
      this.content.setAttribute('aria-hidden', true)
    }

    toggle() {
      this.isVisible() ? this.hide() : this.show()
    }
  }

  customElements.define('x-tab', DoenTab)
}
